module.exports = __webpack_public_path__ + "static/img/blog-comment-three.b834ce1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/blog-comment-three.jpg
// module id = 3//O
// module chunks = 36